import React, { useState } from 'react';
import { Popover, Button, Menu } from '@fx-ui/fine-design';
import { IconFont } from '~/components';
import Intl from '@fx-ui/intl';

interface IAppInstall {
    installApp: (withData: boolean) => Promise<any>;
}
const AppInstall: React.FC<IAppInstall> = (props) => {
    const { installApp } = props;
    const [menuVisible, setMenuVisible] = useState<boolean>(false);
    const [isAppInstalling, setIsAppInstalling] = useState<boolean>(false);

    const handleInstallBtnClick = (withData: boolean) => {
        setIsAppInstalling(true);
        return installApp(withData)
            .then(() => {
                if (!withData) {
                    setMenuVisible(false);
                }
            })
            .finally(() => {
                setIsAppInstalling(false);
            });
    };

    return (
        <Popover
            visible={menuVisible}
            hasPadding={false}
            arrow={false}
            placement="bottom-right"
            trigger="click"
            popupMatchTriggerWidth
            content={
                <Menu
                    className="fx-app-install-popover"
                    items={[{ label: Intl.get('template.install.withoutData') }]}
                    onAfterSelect={() => {
                        return handleInstallBtnClick(false);
                    }}
                />
            }
            onVisibleChange={(visible) => {
                if (!visible) {
                    setMenuVisible(visible);
                }
            }}
        >
            <Button.Group type="primary" className="fx-app-install">
                <Button
                    loading={isAppInstalling}
                    onClick={() => {
                        return handleInstallBtnClick(true);
                    }}
                >
                    {Intl.get('template.install.withData')}
                </Button>
                <Button
                    className="dropdown-btn"
                    type="primary"
                    icon={<IconFont className="install-btn-icon" type="angle-down" />}
                    onClick={() => setMenuVisible(true)}
                />
            </Button.Group>
        </Popover>
    );
};

export default AppInstall;
